import React from "react";
import { Container, Col, Row } from "../../components/grid";
import {
  Paragraph,
  Heading1,
  Span,
  Heading2,
  LinkStyled,
} from "../../components/typography";
import PageLink from "../../components/PageLink";
import SidemenuLayout from "../../layout/DefaultLayout/Layouts/SidemenuLayout";
import { Price } from "../../containers/commerce";
import Datoer from "../../components/Datoer";
import RowProductView from "../../components/grid/RowProductView";

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Fadoel">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Fadøl</Heading1>
          <Paragraph>
            Med næsten <Datoer type="experience" /> års erfaring med levering af fadøl, har vi et bundsolidt kendskab til branchen og ved hvad der kræves, for at gøre enhver fadølselsker glad og tilfreds. Herunder finder du vores enorme udvalg af fadøl, hvor der er garanteret noget for enhver smag.
          </Paragraph>
          <Paragraph>
            <Span fontWeight="bold" fontSize="16px">
              Husk fadølsanlægget
            </Span>
            <br />
            Har du ikke anlægget selv? Så husk, at du kan <LinkStyled to="/fadoelsanlaeg">leje et fadølsanlæg</LinkStyled> til de fadølsfustager, du køber hos os.
          </Paragraph>
          <Paragraph>
            <Span fontWeight="bold" fontSize="16px">
              Returnér dine ubrugte fustager
            </Span>
            <br />
            Betal kun for det I drikker - fustager der ikke er brugt, refunderes til fuld pris minus <Price varenr="641" /> kr. pr. stk.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <PageLink
          title="Pilsner"
          link="/fadoel/pilsner"
          image1="produkter-fadoel.skovlyst-birkebryg.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          image2="produkter-fadoel.groen-tuborg.png"
          image2Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Stort udvalg af Pilsner-fadøl. Tuborg, Carlsberg, Royal til
                Skovlyst, Nørrebro og Svaneke.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Classic"
          link="/fadoel/classic"
          image1="produkter-fadoel.tuborg-classic.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          image2="produkter-fadoel.skovlyst-egebryg.png"
          image2Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Stort udvalg af Classic-fadøl. Tuborg, Carlsberg, Royal til
                Albani, Hancock og Svaneke.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Hvedeøl"
          link="/fadoel/hvedeoel"
          image1="produkter-fadoel.8495-flaske.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          image2="produkter-fadoel.8855-flaske.png"
          image2Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Hvede-fadøl. Flere forskellige typer - fra Kronenbourg 1664
                Blanc til Hoegaarden.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="IPA"
          link="/fadoel/ipa"
          image1="produkter-fadoel.royal-oekologisk-ipa-glas.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          image2="produkter-fadoel.skovlyst-india-pale-ale.png"
          image2Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Flere gode India Pale Ale (IPA) fadøl. Royal, Nørrebro,
                Skovlyst, Herslev, Schiøtz med flere.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Ale"
          link="/fadoel/ale"
          image1="produkter-fadoel.skovlyst-boegebryg.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          image2="produkter-fadoel.fuglsang-early-bird-glas.png"
          image2Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Stort udvalg i Ale - Vælg mellem diverse Brown Ale, Lys Ale og
                Mørk Ale.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Porter / Stout"
          link="/fadoel/porter"
          image1="produkter-fadoel.guinness.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Porter / Stout - Vælg mellem to klassikere: Guinness eller
                Murphy&apos;s Irish Stout.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Letøl"
          link="/fadoel/letoel"
          image1="produkter-fadoel.platan-pilsner.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Letøl og alkoholfri fadøl. Vores alkoholfri fadøl er en
                alkoholfri pilsner fra Tjekkiet. Letøl er fra Herslev og
                Vestfyen.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Cocktails, vin &amp; cider"
          link="/fadoel/cocktails-vin-cider"
          image1="produkter-fadoel.serena-vino-glas.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          image2="produkter-oelvand.nohrlund-mango-smash.png"
          image2Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Cocktails, vin &amp; cider på fad. Få kold æblecider ud af
                fadølshanen eller vælg mellem vores mange gode færdigblandede
                cocktails.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Oktoberfest øl"
          link="/fadoel/oktoberfest"
          image1="produkter-fadoel.paulaner-oktober-fest.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          image2="produkter-fadoel.8495-flaske.png"
          image2Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Gode fadøl til jeres oktoberfest. Vi fører blandt andet en af de
                officiele oktoberfest fadøl Paulaner.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Juleøl"
          link="/fadoel/juleoel"
          image1="produkter-fadoel.tuborg-julebryg.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Fadøl til julefrokosten eller julefesten. Vi har en række gode
                og populære juleøl som passer perfekt til dit event.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Påskebryg"
          link="/fadoel/paaskebryg"
          image1="produkter-fadoel.herslev-paaskebryg-logo.jpg"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Gå ind i foråret med en fadøl fra vores udvalg af påskebryg fra
                Nørrebro, Herslev, samt Fynsk Forår fra Ørbæk.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Dansk Fadøl"
          link="/fadoel/dansk-fadoel"
          image1="produkter-fadoel.hancock-pilsner.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Oversigt over alle vores danske fadøl fra de største producenter
                i Danmark til mindre lokale bryggerier.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Udenlandske øl på fad"
          link="/fadoel/udenlandske-oel-paa-fad"
          image1="produkter-fadoel.heineken.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Oversigt over alle vores udenlandske fadøl fra hele verden. Find
                den rette specielle øl til dit arrangement her.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Modular 20"
          link="/fadoel/modular-20"
          image1="modular20.groen-tuborg.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Modular 20 fustager. Disse fustager kræver eget Modular 20
                anlæg. Vi udlejer ikke udstyret til disse fustager.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Flex 20"
          link="/fadoel/flex-20"
          image1="flex20.carlsberg-pilsner.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Flex 20 fustager (med slange) lagerføres ikke, men tages kun
                hjem på bestilling og mod forud betaling, ingen returret,
                leveringstid 4 dage.
              </Paragraph>
            </React.Fragment>
          )}
        />
        <PageLink
          title="Fadølspriser"
          link="/fadoel/priser"
          image1="produkter-fadoel.groen-tuborg.png"
          image1Size={["140px", "100px", "130px", "120px", "100px", "100px"]}
          paragraph={(
            <React.Fragment>
              <Paragraph>
                Se en oversigt over alle vores fadøl og sorter efter pris, land,
                alkoholprocent, fadkobling med mere.
              </Paragraph>
            </React.Fragment>
          )}
        />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>40 års erfaring og ekspertise inden for fadøl</Heading2>
          <Paragraph>
            Med næsten 40 års erfaring med levering af fadøl har vi hos Skafte et bundsolidt kendskab til branchen og ved, hvad der kræves for at gøre enhver fadølselsker glad og tilfreds. Vores omfattende udvalg af fadøl fustager garanterer noget for enhver smag. Uanset om du søger klassiske pilsnere, mørke ales eller forfriskende IPA&apos;er, finder du det hos os.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Husk fadølsanlægget</Heading2>
          <Paragraph>
            Når du køber fadøl hos Skafte, er det vigtigt at huske fadølsanlægget. Hvis du ikke selv ejer et, tilbyder vi fadølsudlejning, så du kan leje et anlæg til de fustager af fadøl, du køber. Vores udvalg af anlæg passer til alle typer af arrangementer, fra små sammenkomster til store fester. Vi har anlæg med en, to eller tre haner, og du kan vælge mellem forskellige versioner, med eller uden bar.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Få penge tilbage for ubrudte fadølsfustager</Heading2>
          <Paragraph>
            En af vores populære services er, at du kun betaler for det, du drikker. Ubrudte fustager kan returneres, og vi refunderer dem til fuld pris minus <Price varenr="641" /> kr. pr. stk. Dette gør det nemt og bekvemt at bestille mere, end du tror, du har brug for, uden at bekymre dig om spild.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Vores brede udvalg af fadøl</Heading2>
          <Paragraph>
            Hos Skafte finder du et imponerende sortiment af fadøl. Til sommerfesten kan du for eksempel vælge blandt vores lyse hvedeøl, lyse ales og friske IPA’er. En klassiker som Tuborg Classic er altid et sikkert valg, men vi har også spændende varianter fra Nørrebro Bryghus og Kronenbourg. Uanset hvilken type fest du planlægger, har vi den perfekte fadøl til fest.
          </Paragraph>
          <Paragraph>
            Til ølsmagninger og de koldere måneder har vi et velassorteret udvalg af mørkere øltyper. Du kan vælge mellem brown ales, portere og stouts fra populære mærker som Ale no. 16, Newcastle og Guinness. Vi tilbyder også specialøl med rå, ufiltreret smag, herunder IPA, lys og mørk ale samt stout fra kendte bryggerier som Anarkist og Hornbeer.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Bestil fadøl til fest og alle højtider</Heading2>
          <Paragraph>
            Skal du holde en påskefrokost, oktoberfest eller julefrokost? Hos Skafte kan du bestille fadøl til enhver højtid. Vi har et stort udvalg af fadøl, der passer perfekt til de forskellige højtider, og du kan finde dem, der bedst komplementerer din menu ved hjælp af vores beregner. Så får du den bedst mulige smagsoplevelse til dine festlige sammenkomster.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Alkoholfri fadøl og letøl</Heading2>
          <Paragraph>
            Hvis du ikke kan tåle alkohol, eller hvis du blot ønsker at kunne køre hjem efter festen, tilbyder vi både alkoholfri fadøl og letøl. Vores udvalg sikrer, at du kan nyde kvalitetsøl uden at gå på kompromis med smagen. Du kan vælge mellem økologisk landøl eller klassiske varianter som Willemoes Light. Med vores alkoholfri varianter kan du trygt nyde et par fadøl uden bekymringer.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Alternativer til fadøl</Heading2>
          <Paragraph>
            Er du mere til <LinkStyled to="/fadoel/cocktails-vin-cider">cocktails eller cider</LinkStyled>? Hos Skafte kan du bestille lækre cocktails som Gin Hass og Champagne Brus eller vælge klassisk Somersby Apple Cider. Dette gør sig glimrende til sommerfester og giver en forfriskende variation for dem, der ikke bryder sig om fadøl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Sådan bestiller du fadøl hos Skafte.dk</Heading2>
          <Paragraph>
            Det er let at bestille fadøl hos Skafte. På vores hjemmeside finder du en oversigt over vores mange varianter af fadøl. Ønsker du at se specifikke typer af fadøl, kan du nemt navigere gennem vores kategorier og finde præcis det, du leder efter. Uanset om du vil købe fadøl til en lille sammenkomst eller en stor fest, har vi alt, hvad du behøver.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Fadølsudlejning og tilbehør</Heading2>
          <Paragraph>
            Udover fadøl tilbyder vi også udlejning af anlæg og barer. Vores udvalg af barer passer til forskellige typer af arrangementer og fester. Desuden har vi alt nødvendigt tilbehør, såsom kulsyre, reservedele og tappeudstyr. Dette sikrer, at du får en problemfri oplevelse, når du serverer fadøl til dine gæster.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Kundeservice og support</Heading2>
          <Paragraph>
            Vi hos Skafte er dedikerede til at give dig den bedste oplevelse. Hvis du har spørgsmål eller mangler noget uddybet, er du altid velkommen til at kontakte os. Vores eksperter står klar til at hjælpe dig med at vælge de rette produkter og services til din fest. Du finder vores kontaktoplysninger herunder, og vi ser frem til at hjælpe dig med at gøre din næste fest til en succes.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Fadølsudlejning hos Skafte</Heading2>
          <Paragraph>
            Hos Skafte tilbyder vi også fadølsudlejning, så du kan få leveret og installeret et komplet fadølsanlæg til din fest eller begivenhed. Vores fagfolk sikrer, at anlægget fungerer perfekt. Uanset om du holder en lille sammenkomst eller en stor begivenhed, har vi løsningen for dig. Bestil fadølsudlejning sammen med din bestilling af fadøl, så sørger vi for resten, og du kan fokusere på at nyde festen med dine gæster.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Derfor skal du vælge Skafte til levering af fadøl</Heading2>
          <Paragraph>
            Når du vælger Skafte til dine fadølsbehov, får du ikke kun adgang til et bredt udvalg af kvalitetsøl, men også en række fordele, der gør din oplevelse bedre. Vi tilbyder fleksible lejeaftaler og professionel installation, samt muligheden for at returnere ubrudte fustager med fadøl. Dette gør os til den ideelle partner, når du skal holde fest eller arrangere en begivenhed.
          </Paragraph>
          <Paragraph>
            Hos Skafte er vi stolte af vores omfattende udvalg og vores engagement i at levere den bedste service til vores kunder. Uanset hvilken type fadøl du søger, og hvilken slags fest du planlægger, kan du stole på at Skafte leverer produkter og service af højeste kvalitet.
          </Paragraph>
          <Paragraph>
            Kontakt os i dag for at bestille din næste levering af fadøl, eller hvis du har spørgsmål om vores produkter og services. Vi ser frem til at hjælpe dig med at gøre din næste fest til en mindeværdig begivenhed med lækker fadøl og professionel service fra Skafte.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Husk fadølsanlægget</Heading2>
          <Paragraph>
            Når du køber fadøl hos Skafte, er det vigtigt at huske fadølsanlægget. Hvis du ikke selv ejer et, tilbyder vi fadølsudlejning, så du kan leje et anlæg til de fustager af fadøl, du køber. Vores udvalg af anlæg passer til alle typer af arrangementer, fra små sammenkomster til store fester. Vi har anlæg med en, to eller tre haner, og du kan vælge mellem forskellige versioner, med eller uden bar.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
